// extracted by mini-css-extract-plugin
module.exports = {"switchBox":"SwitchBox_switchBox__24ou7","label":"SwitchBox_label__ypHJy"};